import React from 'react';
import styled from 'styled-components';
import * as CONSTANTS from '../constants';
import { ModalContext } from '../context/modal';
import { logEvent } from '../utils/analytics';

const SubmitSite = styled.button`
	display: table;
	margin: 10px auto 0 auto;
	font-size: 11px;

  ${CONSTANTS.basicCTA}
  
  ${props => (props.darkMode === true ? `color: #717171;border-color: #717171; &:hover{color: #444;border-color: #444;}` : '')}

	&:hover {
		${props => (props.darkMode === true ? `color: #444;border-color: #444;` : 'opacity: 0.5;')}
	}
`;


export default class SubmitSiteButton extends React.Component {
  constructor(props) {
    super(props);

    this.showModal = this.showModal.bind(this);
  }

  showModal(e, modalName) {
    e.preventDefault();
  
    this.context.updateValue('currentModal', modalName);
    logEvent('details page submit a site button', 'click');
  }

  render () {
    return (
      <SubmitSite
        onClick={(e) => this.showModal(e, 'submission')}
        isVisible={this.props.isVisible}
        darkMode={this.context.darkMode}
        dangerouslySetInnerHTML={{__html: this.props.text}}
      />
    );
  }
}

SubmitSiteButton.contextType = ModalContext;
